exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header+div[data-v-5ee58055]{padding-top:5px}", ""]);

// exports
